import { Component, computed, effect, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatDrawer } from '@angular/material/sidenav';
import { AccountService } from '@jfw/angular/shared/services';
import { ModuleSuiteEnum } from '@jfw/types';
import { AuthService } from '../../../services/auth/auth.service';
import { AccountStoreInfoComponent } from './account-store-info/account-store-info.component';
import { CommentsComponent } from './comments/comments.component';
import { ShippingInfoComponent } from './shipping-info/shipping-info.component';

@Component({
  selector: 'app-account-info-drawer',
  templateUrl: './account-info-drawer.component.html',
  styleUrls: ['./account-info-drawer.component.scss'],
  imports: [
    MatIcon,
    MatButtonModule,
    AccountStoreInfoComponent,
    ShippingInfoComponent,
    CommentsComponent,
  ],
})
export class AccountInfoDrawerComponent {
  private readonly authService = inject(AuthService);
  private readonly accountService = inject(AccountService);

  public readonly drawer = input<MatDrawer>();

  private readonly currentSuite = toSignal(this.authService.currentSuite$);
  protected readonly displayDrawer = computed(() =>
    [ModuleSuiteEnum.Wholesale, ModuleSuiteEnum.Accounting].includes(
      this.currentSuite()?.enum as ModuleSuiteEnum,
    ),
  );

  protected readonly platformAccount = this.accountService._platformAccount;

  protected readonly drawerState = computed(() =>
    this.accountService.drawerState(),
  );

  constructor() {
    // AC#4 fix: displayDrawer() already tears down this component's own template
    // (via the parent's @if) once the route falls outside Wholesale/Accounting, but
    // nothing previously told the shell's `<mat-drawer [opened]="showDrawer()">`
    // (app.component.html) to close too — leaving the panel open and blank. Closing
    // it here keeps the fix scoped to this component rather than the app shell/Router.
    effect(() => {
      if (!this.displayDrawer()) {
        this.accountService.showDrawer.set(false);
      }
    });
  }

  protected setTab(tab: string): void {
    this.accountService.selectDrawerTab(tab);
  }

  protected close(): void {
    this.accountService.showDrawer.set(false);
  }
}
